export default __webpack_public_path__ + "static/media/waiting-for-payment.23cdb4f6.svg";